module.exports = __webpack_public_path__ + "static/media/09GalleryPuppets.225f1e6a.jpeg";